import React from 'react';
import {
  Filter, ReferenceInput, SelectInput, useListContext,
} from 'react-admin';
import IAuditTrack from '../../utilities/schemas/auditTrack';
import resourceNames from '../../constants/resourceNames';
import resourceTypes, { ResourceTypes } from '../../constants/resourceTypes';
import internalResourceTypes from '../../constants/internalResourceTypes';
import resourceTypeLabels from '../../constants/resourceTypeLabels';

const fetchUser = (search: string) => ({ authenticator: search });

const resourceTypeChoices = (Object.values(resourceTypes) as ResourceTypes[])
  .filter((type) => !internalResourceTypes.includes(type))
  .map((type) => ({ id: type, name: resourceTypeLabels[type] }));

const AuditFilter = ({ context }: { context?: 'form' | 'button' }) => {
  const { filterValues } = useListContext<IAuditTrack>();
  return (
    <Filter context={context}>
      <SelectInput
        source="resource.type"
        label="Resource Type"
        choices={resourceTypeChoices}
        alwaysOn
        SelectProps={{
          disableUnderline: true,
        }}
      />
      <SelectInput
        source="authenticator.type"
        label="User Type"
        choices={[
          { id: 'System', name: 'System' },
          { id: 'Member', name: 'Members' },
          { id: 'ApiKey', name: 'Api key' },
        ]}
        alwaysOn
        SelectProps={{
          disableUnderline: true,
        }}
      />
      {filterValues?.authenticator?.type === 'Member' && (
        <ReferenceInput
          label="Member"
          source="authenticator.id"
          reference={resourceNames.MEMBERS}
          filterToQuery={fetchUser}
          alwaysOn
        >
          <SelectInput
            SelectProps={{
              disableUnderline: true,
            }}
            label="Member"
            optionText={(member) => `${member.firstName} ${member.lastName}`}
          />
        </ReferenceInput>
      )}
      {filterValues?.authenticator?.type === 'ApiKey' && (
        <ReferenceInput
          label="Client ID"
          source="authenticator.id"
          reference={resourceNames.API_KEYS}
          filterToQuery={fetchUser}
          alwaysOn
        >
          <SelectInput
            SelectProps={{
              disableUnderline: true,
            }}
            label="Client ID"
            optionText={(user) => `${user.clientId}`}
          />
        </ReferenceInput>
      )}
    </Filter>
  );
};

export default AuditFilter;
